import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import Button from "sushiweb/Button";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import Input from "sushiweb/InputTypes/Input";
import Textarea from "sushiweb/InputTypes/Textarea";
import {
  BottomSectionModal,
  FieldsContainer,
  FlexContainer,
} from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import { getBulkCities, getCity, getCityList } from "../../store/actions/City";
import {
  getAppReleasesList,
  resetState,
} from "../../store/actions/DriverAppReleases";
import {
  getBulkLocalities,
  getLocality,
  getLocalityList,
} from "../../store/actions/Locality";
import { isValNull, removeEmptyVals, setNestedKeyValue } from "../../utils";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import NoFooterModal from "../Common/NoFooterModal";

const AppReleasesFilterModal = ({
  handleModalClose,
  localityList,
  cityList,
  nextPageCity,
  nextPageLocality,
  getLocalityList,
  getCity,
  getCityList,
  getLocality,
  resetState,
  activeFilters,
  getAppReleasesList,
  currentPage,
}) => {
  const location = useLocation();
  const searchQueryParams = location.search;
  const paramsObject = new URLSearchParams(searchQueryParams);
  const actionType = paramsObject.get("type");
  const appReleaseId = paramsObject.get("id");
  const appReleaseVersion = paramsObject.get("version");
  const [priorityFlag, setPriorityFlag] = useState(false);
  const [initialState, setInitialState] = useState({
    version: "",
    fe_ids: [],
    // release_notes: "",
    city_ids: [],
    locality_ids: [],
    stable: "",
    show_on_driver_edit: "",
    created_at: {
      start_date: "",
      end_date: "",
    },
  });

  const handleSubmit = () => {
    const payload = removeEmptyVals(initialState);
    getAppReleasesList(payload).then((_) => {
      handleModalClose();
    });
  };

  const handleClearFilters = () => {
    if (!isValNull(activeFilters)) {
      getAppReleasesList({}).then((_) => {
        handleModalClose();
      });
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    let finalVal = val;
    if (key == "city_ids") {
      setPriorityFlag(true);
      values["locality_ids"] = [];
    }
    if (key === "locality_ids") {
      setPriorityFlag(false);
    }
    if (key === "fe_ids") {
      finalVal = val.split(",");
    }
    setNestedKeyValue(values, key, finalVal);
    setInitialState(values);
  };

  useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      if (activeFilters.locality_ids && activeFilters.locality_ids.length > 0) {
        setPriorityFlag(true);
      }
      Object.keys(values).map((key, idx) => {
        if (!isValNull(activeFilters[key])) {
          values[key] = activeFilters[key] ? activeFilters[key] : "";
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading="Apply filters"
      handleClose={handleModalClose}
      id="filtersModalAppReleases"
      modalButtons={
        <BottomSectionModal className="flex item-center justify-between">
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
            appearance="outline"
          >
            Clear
          </Button>
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.version}
        data-testid="appVersionField"
        id="sushi-input"
        onChange={(e) => handleChange("version", e)}
        label="Version"
        innerWidth="50%"
        className="mr-40"
      />
      <Input
        value={isValNull(initialState.fe_ids) ? "" : initialState.fe_ids}
        data-testid="Fe_idsAppVersion"
        id="sushi-input"
        onChange={(e) => handleChange("fe_ids", e)}
        label="Driver FE Ids (comma separated)"
      />
      {/* <Textarea
        id="sushi-textarea"
        borderColor={variables.primaryColor}
        className="mb-20"
        resize="none"
        innerWidth="100%"
        label="Release notes"
        onChange={(e) => handleChange("release_notes", e)}
        value={initialState.release_notes}
      /> */}
      <InfiniteScrollDropdown
        id="cityDropdownAppRelease"
        multiple
        priorityFlag={true}
        appliedFilters={{}}
        getActiveList={getCityList}
        nextPage={nextPageCity}
        resKey="cities"
        modalState={"Filter"}
        keyName="city_ids"
        labelKey="city_name"
        getDataLabelKey="city.city_name"
        keyTypeToSet="id"
        label="Cities"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={activeFilters}
        // activeElement={activeFeatureToggle}
        getActiveItemById={getCity}
      />
      <InfiniteScrollDropdown
        id="localityDropdownAppRelease"
        multiple
        setPriorityFlag={setPriorityFlag}
        priorityFlag={priorityFlag}
        appliedFilters={
          initialState.city_ids ? { city_id: initialState.city_ids } : {}
        }
        getActiveList={getLocalityList}
        nextPage={nextPageLocality}
        resKey="localities"
        modalState={"Filter"}
        keyName="locality_ids"
        labelKey="locality_name"
        labels={["locality_name", "id"]}
        getDataLabelKey="locality.locality_name"
        keyTypeToSet="id"
        getActiveItemById={getLocality}
        label="Localities"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={initialState}
        // activeElement={}
      />
      <FlexContainer className="mt-30" justify="flex-start">
        <Checkbox
          value="stable"
          color={variables.red500}
          checked={initialState.stable}
          onChange={(e) => handleChange("stable", e.stable)}
          className="sushi-checkbox mr-40"
          label="Stable"
        />
        <Checkbox
          value="show_on_driver_edit"
          color={variables.red500}
          checked={initialState.show_on_driver_edit}
          onChange={(e) =>
            handleChange("show_on_driver_edit", e.show_on_driver_edit)
          }
          className="sushi-checkbox"
          label="Show on driver edit"
        />
      </FlexContainer>
      <div className="created-at-fields">
        <h4>Created at</h4>
        <FieldsContainer border className="created-at-container">
          <FlexContainer justify="flex-start">
            <Input
              id="sushi-input"
              value={initialState.created_at.start_date || " "}
              fullWidth={true}
              label="From"
              type="date"
              onChange={(val) => handleChange("created_at.start_date", val)}
            />
            <Input
              id="sushi-input"
              fullWidth={true}
              value={initialState.created_at.end_date || " "}
              label="To"
              type="date"
              onChange={(val) => handleChange("created_at.end_date", val)}
            />
          </FlexContainer>
        </FieldsContainer>
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { City, Locality, DriverAppReleases } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    activeFilters: DriverAppReleases.activeFilters,
    currentPage: DriverAppReleases.currentPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLocalityList: bindActionCreators(getLocalityList, dispatch),
    getCity: bindActionCreators(getBulkCities, dispatch),
    getLocality: bindActionCreators(getBulkLocalities, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
    getAppReleasesList: bindActionCreators(getAppReleasesList, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppReleasesFilterModal);
